<template>
  <div class="activities">
    <div class="title">
      <div></div>
      活动列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-select v-model="types" placeholder="请选择状态">
          <el-option label="全部" value="全部">全部</el-option>
          <el-option label="未开始" value="未开始">未开始</el-option>
          <el-option label="已结束" value="已结束">已结束</el-option>
          <el-option label="进行中" value="进行中">进行中</el-option>
        </el-select>
      </div>
      <div class="query-box">
        <el-input v-model="query" placeholder="活动名称/酒吧名称"></el-input>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
       <el-button type="primary" @click="derive">导出</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
       <el-table-column align="center" prop="barName" label="酒吧名称">
        </el-table-column>
        <el-table-column align="center" prop="activityName" label="活动名称">   
        </el-table-column>
        <el-table-column align="center" prop="activityTime" label="活动时间">
        </el-table-column>

        <el-table-column align="center" prop="content" label="活动介绍">
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>

        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <div :class="scope.row.isExpire == 3 ? 'active' : ''">
              {{
                scope.row.isExpire == 1
                  ? "未开始"
                  : scope.row.isExpire == 2
                  ? "已结束"
                  : "进行中"
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="activityEdit(scope.row.id)"
              >编辑</el-button
            >
             <el-button
              size="mini"
              type="danger"
              @click="del(scope.row.id)"
              >删除</el-button
            >
          </template>
          
         
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { allActivity,functiondownload,delActivity} from "@/api/api";
export default {
  data() {
    return {
      ruleList: [],
      query: "",
      startTime: "",
      endTime: "",
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      types: "",
      type: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
      // 删除活动
    del(id) {
      this.$confirm("将删除此活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delActivity({
            id: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

      // 导出
    derive(){
       functiondownload('/web/bar/allActivityExport',{ 
        query:this.query,
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.type
        
        },true)
    },

    activityEdit(id) {
      this.$router.push("allActivityEdit?activityId=" + id);
    },
    querys() {
      if (this.activityTime == null) {
        (this.startTime = ""), (this.endTime = "");
      }
    },
    //  获取活动列表
    async getList() {
      let res = await allActivity({
        query: this.query,
        barId: this.$route.query.barId,
        startTime: this.startTime,
        endTime: this.endTime,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        type: this.type,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.itemList;
      this.total = data.totalSize;
    },
 
    // 查询
    inquire() {

       if(this.types=='全部'){
         this.type=''
       }else if(this.types=='未开始'){
         this.type=1
       }  else if(this.types=='已结束'){
         this.type=2
       }   else if(this.types=='进行中'){
         this.type=3
       } 

      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
</style>